import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpcoesPaginacao from '../comum/OpcoesPaginacao';
import alterarRegistrosPorPagina from '../../actions/selecao-empresa/alterarRegistrosPorPaginaSelecaoEmpresa';
import determinarPaginaAtual from '../../actions/selecao-empresa/determinarPaginaAtualSelecaoEmpresa';

export class OpcoesPaginacaoSelecaoEmpresa extends Component {
  render() {
    if (this.props.empresas.length === 0) {
      return '';
    }

    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.empresas.length}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      opcaoDoze
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>;
  }
}

export function mapStateToProps(state) {
  return {
    empresas: state.authentication.empresasSelecao,
    paginaAtual: state.paginaAtualSelecaoEmpresa,
    registrosPorPagina: state.registrosPorPaginaSelecaoEmpresa
  };
}

export default connect(mapStateToProps, {
  alterarRegistrosPorPagina,
  determinarPaginaAtual
})(OpcoesPaginacaoSelecaoEmpresa);
